module.exports = __webpack_public_path__ + "static/media/google-play-badge_de.63f7cc1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/google-play-badge_de.png
// module id = 304
// module chunks = 21